(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode("._htmlOpen_1cowi_1{overflow-y:hidden}._content_1cowi_5{--modal-header-color: var(--uikit-text-new-primary, #141414);--modal-background-color: var(--uikit-surface-new-00, #ffffff);--modal-error-icon: var(--uikit-bg-c-negative, #d4083b);--modal-success-icon: var(--uikit-bg-c-positive, #358730);--modal-informal-icon: var(--uikit-bg-c-informal, #3d73d8);--modal-warning-icon: var(--uikit-bg-c-warning, #d63d00);--modal-width: var(--ui-modal-width, 680px);position:absolute;left:50%;box-sizing:border-box;width:calc(100% - 32px);max-width:var(--modal-width);padding:32px 36px 40px;background:var(--modal-background-color);outline:none;transform:translate(-50%);font-family:Hauss,sans-serif;font-weight:400;font-size:1rem;line-height:1.5rem;letter-spacing:normal}._errorIcon_1cowi_29{display:inline-flex;color:var(--modal-error-icon)}._successIcon_1cowi_34{display:inline-flex;color:var(--modal-success-icon)}._informalIcon_1cowi_39{display:inline-flex;color:var(--modal-informal-icon)}._warningIcon_1cowi_44{display:inline-flex;color:var(--modal-warning-icon)}._headerWrapper_1cowi_49{display:flex;align-items:center;margin-block-end:18px}._headerWrapper_1cowi_49 svg{margin-inline-end:10px}._header_1cowi_49{font-family:Hauss,sans-serif;font-weight:500;font-size:2rem;line-height:2.5rem;letter-spacing:normal;color:var(--modal-header-color);margin-block:0}._overlay_1cowi_68{--modal-overlay-color: var(--ui-modal-overlay-color, #c4c4c465);--modal-z-index: var(--ui-modal-z-index, 1);--modal-overflow-y: var(--ui-modal-overflow-y, scroll);position:fixed;z-index:var(--modal-z-index);overflow-y:var(--modal-overflow-y);background-color:var(--modal-overlay-color);top:0;right:0;bottom:0;left:0}._closeButton_1cowi_79{position:absolute;inset-block-start:8px;inset-inline-end:8px}._closeButton_1cowi_79 svg{margin-inline-end:0}._footerWrapper_1cowi_88{--ui-button-width: 100%;display:flex;gap:40px;justify-content:space-between;margin-block-start:32px;font-family:Hauss,sans-serif;font-weight:500;font-size:1rem;line-height:1.5rem;letter-spacing:normal}{}.ReactModal__Overlay{opacity:0;transition:opacity .1s ease-in-out}.ReactModal__Content{transition:all .1s ease-in-out}.ReactModal__Overlay--after-open{opacity:1}.ReactModal__Overlay--before-close{opacity:0}.ReactModal__Content--after-open{transform:translate(-50%,64px);opacity:1}.ReactModal__Content--before-close{transform:translate(-50%);opacity:0}._wrapper_la23x_1{--floating-modal-border-color: var( --ui-floating-modal-border-color, var(--uikit-dark-fixed-bg-c-default-inverse, #000000) );--floating-modal-background-color: var( --ui-floating-modal-background-color, var(--uikit-dark-fixed-text-new-primary-inverse, #f3f3f3) );--floating-modal-drag-icon-color: var( --ui-floating-modal-drag-icon-color, var(--uikit-dark-fixed-bg-c-default-inverse, #000000) );--floating-modal-width: var(--ui-floating-modal-width, 420px);--floating-modal-default-position-top: var(--ui-floating-button-default-position-top, auto);--floating-modal-default-position-right: var(--ui-floating-button-default-position-right, auto);--floating-modal-default-position-left: var(--ui-floating-button-default-position-left, auto);--floating-modal-default-position-bottom: var(--ui-floating-button-default-position-bottom, auto);--floating-modal-position: var(--ui-floating-modal-position, absolute);position:var(--floating-modal-position);z-index:9;display:flex;flex-direction:column;width:var(--floating-modal-width);max-width:100%;max-height:100%;overflow:hidden;background-color:var(--floating-modal-background-color);border:1px solid var(--floating-modal-border-color);inset:var(--floating-modal-default-position-top) var(--floating-modal-default-position-right) var(--floating-modal-default-position-bottom) var(--floating-modal-default-position-left);row-gap:4px}._controller_la23x_34{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:4px}._dragIcon_la23x_42{display:flex;padding:8px;color:var(--floating-modal-drag-icon-color);cursor:move;place-content:center center}._content_la23x_50{flex-grow:1;padding:0 16px 24px;overflow:auto}")),document.head.appendChild(o)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import Ke, { useRef as Fr, useLayoutEffect as Mn, useMemo as Nn, useEffect as An, useState as In } from "react";
import Kt from "react-dom";
import { TextButton as vr, InlineButton as jn, IconButton as Wn } from "@platform/ui-buttons";
import { Wrapper as kr } from "@platform/ui-wrapper";
function Gt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Lr(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var kt = { exports: {} }, tt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yr;
function $n() {
  if (yr) return tt;
  yr = 1;
  var e = Ke, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function v(i, _, m) {
    var g, h = {}, O = null, D = null;
    m !== void 0 && (O = "" + m), _.key !== void 0 && (O = "" + _.key), _.ref !== void 0 && (D = _.ref);
    for (g in _) r.call(_, g) && !s.hasOwnProperty(g) && (h[g] = _[g]);
    if (i && i.defaultProps) for (g in _ = i.defaultProps, _) h[g] === void 0 && (h[g] = _[g]);
    return { $$typeof: t, type: i, key: O, ref: D, props: h, _owner: a.current };
  }
  return tt.Fragment = n, tt.jsx = v, tt.jsxs = v, tt;
}
var rt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mr;
function Fn() {
  return mr || (mr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ke, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), v = Symbol.for("react.provider"), i = Symbol.for("react.context"), _ = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), O = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), I = Symbol.iterator, j = "@@iterator";
    function Y(o) {
      if (o === null || typeof o != "object")
        return null;
      var b = I && o[I] || o[j];
      return typeof b == "function" ? b : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function X(o) {
      {
        for (var b = arguments.length, C = new Array(b > 1 ? b - 1 : 0), W = 1; W < b; W++)
          C[W - 1] = arguments[W];
        q("error", o, C);
      }
    }
    function q(o, b, C) {
      {
        var W = F.ReactDebugCurrentFrame, B = W.getStackAddendum();
        B !== "" && (b += "%s", C = C.concat([B]));
        var K = C.map(function(U) {
          return String(U);
        });
        K.unshift("Warning: " + b), Function.prototype.apply.call(console[o], console, K);
      }
    }
    var G = !1, T = !1, le = !1, Te = !1, Re = !1, ye;
    ye = Symbol.for("react.module.reference");
    function De(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === r || o === s || Re || o === a || o === m || o === g || Te || o === D || G || T || le || typeof o == "object" && o !== null && (o.$$typeof === O || o.$$typeof === h || o.$$typeof === v || o.$$typeof === i || o.$$typeof === _ || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === ye || o.getModuleId !== void 0));
    }
    function ge(o, b, C) {
      var W = o.displayName;
      if (W)
        return W;
      var B = b.displayName || b.name || "";
      return B !== "" ? C + "(" + B + ")" : C;
    }
    function ce(o) {
      return o.displayName || "Context";
    }
    function re(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && X("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case i:
            var b = o;
            return ce(b) + ".Consumer";
          case v:
            var C = o;
            return ce(C._context) + ".Provider";
          case _:
            return ge(o, o.render, "ForwardRef");
          case h:
            var W = o.displayName || null;
            return W !== null ? W : re(o.type) || "Memo";
          case O: {
            var B = o, K = B._payload, U = B._init;
            try {
              return re(U(K));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var x = Object.assign, A = 0, k, l, M, z, d, E, u;
    function c() {
    }
    c.__reactDisabledLog = !0;
    function f() {
      {
        if (A === 0) {
          k = console.log, l = console.info, M = console.warn, z = console.error, d = console.group, E = console.groupCollapsed, u = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: c,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        A++;
      }
    }
    function y() {
      {
        if (A--, A === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: x({}, o, {
              value: k
            }),
            info: x({}, o, {
              value: l
            }),
            warn: x({}, o, {
              value: M
            }),
            error: x({}, o, {
              value: z
            }),
            group: x({}, o, {
              value: d
            }),
            groupCollapsed: x({}, o, {
              value: E
            }),
            groupEnd: x({}, o, {
              value: u
            })
          });
        }
        A < 0 && X("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var p = F.ReactCurrentDispatcher, S;
    function P(o, b, C) {
      {
        if (S === void 0)
          try {
            throw Error();
          } catch (B) {
            var W = B.stack.trim().match(/\n( *(at )?)/);
            S = W && W[1] || "";
          }
        return `
` + S + o;
      }
    }
    var N = !1, R;
    {
      var J = typeof WeakMap == "function" ? WeakMap : Map;
      R = new J();
    }
    function w(o, b) {
      if (!o || N)
        return "";
      {
        var C = R.get(o);
        if (C !== void 0)
          return C;
      }
      var W;
      N = !0;
      var B = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var K;
      K = p.current, p.current = null, f();
      try {
        if (b) {
          var U = function() {
            throw Error();
          };
          if (Object.defineProperty(U.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(U, []);
            } catch (Me) {
              W = Me;
            }
            Reflect.construct(o, [], U);
          } else {
            try {
              U.call();
            } catch (Me) {
              W = Me;
            }
            o.call(U.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Me) {
            W = Me;
          }
          o();
        }
      } catch (Me) {
        if (Me && W && typeof Me.stack == "string") {
          for (var L = Me.stack.split(`
`), se = W.stack.split(`
`), ee = L.length - 1, te = se.length - 1; ee >= 1 && te >= 0 && L[ee] !== se[te]; )
            te--;
          for (; ee >= 1 && te >= 0; ee--, te--)
            if (L[ee] !== se[te]) {
              if (ee !== 1 || te !== 1)
                do
                  if (ee--, te--, te < 0 || L[ee] !== se[te]) {
                    var me = `
` + L[ee].replace(" at new ", " at ");
                    return o.displayName && me.includes("<anonymous>") && (me = me.replace("<anonymous>", o.displayName)), typeof o == "function" && R.set(o, me), me;
                  }
                while (ee >= 1 && te >= 0);
              break;
            }
        }
      } finally {
        N = !1, p.current = K, y(), Error.prepareStackTrace = B;
      }
      var Ve = o ? o.displayName || o.name : "", pr = Ve ? P(Ve) : "";
      return typeof o == "function" && R.set(o, pr), pr;
    }
    function ne(o, b, C) {
      return w(o, !1);
    }
    function ue(o) {
      var b = o.prototype;
      return !!(b && b.isReactComponent);
    }
    function be(o, b, C) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return w(o, ue(o));
      if (typeof o == "string")
        return P(o);
      switch (o) {
        case m:
          return P("Suspense");
        case g:
          return P("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case _:
            return ne(o.render);
          case h:
            return be(o.type, b, C);
          case O: {
            var W = o, B = W._payload, K = W._init;
            try {
              return be(K(B), b, C);
            } catch {
            }
          }
        }
      return "";
    }
    var xe = Object.prototype.hasOwnProperty, We = {}, st = F.ReactDebugCurrentFrame;
    function $e(o) {
      if (o) {
        var b = o._owner, C = be(o.type, o._source, b ? b.type : null);
        st.setExtraStackFrame(C);
      } else
        st.setExtraStackFrame(null);
    }
    function ut(o, b, C, W, B) {
      {
        var K = Function.call.bind(xe);
        for (var U in o)
          if (K(o, U)) {
            var L = void 0;
            try {
              if (typeof o[U] != "function") {
                var se = Error((W || "React class") + ": " + C + " type `" + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[U] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw se.name = "Invariant Violation", se;
              }
              L = o[U](b, U, W, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ee) {
              L = ee;
            }
            L && !(L instanceof Error) && ($e(B), X("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", W || "React class", C, U, typeof L), $e(null)), L instanceof Error && !(L.message in We) && (We[L.message] = !0, $e(B), X("Failed %s type: %s", C, L.message), $e(null));
          }
      }
    }
    var lt = Array.isArray;
    function Qe(o) {
      return lt(o);
    }
    function pn(o) {
      {
        var b = typeof Symbol == "function" && Symbol.toStringTag, C = b && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return C;
      }
    }
    function vn(o) {
      try {
        return nr(o), !1;
      } catch {
        return !0;
      }
    }
    function nr(o) {
      return "" + o;
    }
    function or(o) {
      if (vn(o))
        return X("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pn(o)), nr(o);
    }
    var et = F.ReactCurrentOwner, yn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ar, ir, Tt;
    Tt = {};
    function mn(o) {
      if (xe.call(o, "ref")) {
        var b = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (b && b.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function hn(o) {
      if (xe.call(o, "key")) {
        var b = Object.getOwnPropertyDescriptor(o, "key").get;
        if (b && b.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function gn(o, b) {
      if (typeof o.ref == "string" && et.current && b && et.current.stateNode !== b) {
        var C = re(et.current.type);
        Tt[C] || (X('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', re(et.current.type), o.ref), Tt[C] = !0);
      }
    }
    function bn(o, b) {
      {
        var C = function() {
          ar || (ar = !0, X("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
        };
        C.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: C,
          configurable: !0
        });
      }
    }
    function _n(o, b) {
      {
        var C = function() {
          ir || (ir = !0, X("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
        };
        C.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: C,
          configurable: !0
        });
      }
    }
    var On = function(o, b, C, W, B, K, U) {
      var L = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: o,
        key: b,
        ref: C,
        props: U,
        // Record the component responsible for creating this element.
        _owner: K
      };
      return L._store = {}, Object.defineProperty(L._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(L, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: W
      }), Object.defineProperty(L, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: B
      }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
    };
    function En(o, b, C, W, B) {
      {
        var K, U = {}, L = null, se = null;
        C !== void 0 && (or(C), L = "" + C), hn(b) && (or(b.key), L = "" + b.key), mn(b) && (se = b.ref, gn(b, B));
        for (K in b)
          xe.call(b, K) && !yn.hasOwnProperty(K) && (U[K] = b[K]);
        if (o && o.defaultProps) {
          var ee = o.defaultProps;
          for (K in ee)
            U[K] === void 0 && (U[K] = ee[K]);
        }
        if (L || se) {
          var te = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          L && bn(U, te), se && _n(U, te);
        }
        return On(o, L, se, B, W, et.current, U);
      }
    }
    var Ct = F.ReactCurrentOwner, sr = F.ReactDebugCurrentFrame;
    function He(o) {
      if (o) {
        var b = o._owner, C = be(o.type, o._source, b ? b.type : null);
        sr.setExtraStackFrame(C);
      } else
        sr.setExtraStackFrame(null);
    }
    var Pt;
    Pt = !1;
    function Rt(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function ur() {
      {
        if (Ct.current) {
          var o = re(Ct.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function Sn(o) {
      return "";
    }
    var lr = {};
    function wn(o) {
      {
        var b = ur();
        if (!b) {
          var C = typeof o == "string" ? o : o.displayName || o.name;
          C && (b = `

Check the top-level render call using <` + C + ">.");
        }
        return b;
      }
    }
    function cr(o, b) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var C = wn(b);
        if (lr[C])
          return;
        lr[C] = !0;
        var W = "";
        o && o._owner && o._owner !== Ct.current && (W = " It was passed a child from " + re(o._owner.type) + "."), He(o), X('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', C, W), He(null);
      }
    }
    function fr(o, b) {
      {
        if (typeof o != "object")
          return;
        if (Qe(o))
          for (var C = 0; C < o.length; C++) {
            var W = o[C];
            Rt(W) && cr(W, b);
          }
        else if (Rt(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var B = Y(o);
          if (typeof B == "function" && B !== o.entries)
            for (var K = B.call(o), U; !(U = K.next()).done; )
              Rt(U.value) && cr(U.value, b);
        }
      }
    }
    function Tn(o) {
      {
        var b = o.type;
        if (b == null || typeof b == "string")
          return;
        var C;
        if (typeof b == "function")
          C = b.propTypes;
        else if (typeof b == "object" && (b.$$typeof === _ || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        b.$$typeof === h))
          C = b.propTypes;
        else
          return;
        if (C) {
          var W = re(b);
          ut(C, o.props, "prop", W, o);
        } else if (b.PropTypes !== void 0 && !Pt) {
          Pt = !0;
          var B = re(b);
          X("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", B || "Unknown");
        }
        typeof b.getDefaultProps == "function" && !b.getDefaultProps.isReactClassApproved && X("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Cn(o) {
      {
        for (var b = Object.keys(o.props), C = 0; C < b.length; C++) {
          var W = b[C];
          if (W !== "children" && W !== "key") {
            He(o), X("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", W), He(null);
            break;
          }
        }
        o.ref !== null && (He(o), X("Invalid attribute `ref` supplied to `React.Fragment`."), He(null));
      }
    }
    function dr(o, b, C, W, B, K) {
      {
        var U = De(o);
        if (!U) {
          var L = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var se = Sn();
          se ? L += se : L += ur();
          var ee;
          o === null ? ee = "null" : Qe(o) ? ee = "array" : o !== void 0 && o.$$typeof === t ? (ee = "<" + (re(o.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : ee = typeof o, X("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ee, L);
        }
        var te = En(o, b, C, B, K);
        if (te == null)
          return te;
        if (U) {
          var me = b.children;
          if (me !== void 0)
            if (W)
              if (Qe(me)) {
                for (var Ve = 0; Ve < me.length; Ve++)
                  fr(me[Ve], o);
                Object.freeze && Object.freeze(me);
              } else
                X("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              fr(me, o);
        }
        return o === r ? Cn(te) : Tn(te), te;
      }
    }
    function Pn(o, b, C) {
      return dr(o, b, C, !0);
    }
    function Rn(o, b, C) {
      return dr(o, b, C, !1);
    }
    var Dn = Rn, xn = Pn;
    rt.Fragment = r, rt.jsx = Dn, rt.jsxs = xn;
  }()), rt;
}
process.env.NODE_ENV === "production" ? kt.exports = $n() : kt.exports = Fn();
var Z = kt.exports, Lt = { exports: {} }, qe = {}, Ut = { exports: {} }, ct = { exports: {} }, H = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hr;
function kn() {
  if (hr) return H;
  hr = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, v = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, _ = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, g = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, O = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, j = e ? Symbol.for("react.block") : 60121, Y = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, X = e ? Symbol.for("react.scope") : 60119;
  function q(T) {
    if (typeof T == "object" && T !== null) {
      var le = T.$$typeof;
      switch (le) {
        case t:
          switch (T = T.type, T) {
            case _:
            case m:
            case r:
            case s:
            case a:
            case h:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case i:
                case g:
                case I:
                case D:
                case v:
                  return T;
                default:
                  return le;
              }
          }
        case n:
          return le;
      }
    }
  }
  function G(T) {
    return q(T) === m;
  }
  return H.AsyncMode = _, H.ConcurrentMode = m, H.ContextConsumer = i, H.ContextProvider = v, H.Element = t, H.ForwardRef = g, H.Fragment = r, H.Lazy = I, H.Memo = D, H.Portal = n, H.Profiler = s, H.StrictMode = a, H.Suspense = h, H.isAsyncMode = function(T) {
    return G(T) || q(T) === _;
  }, H.isConcurrentMode = G, H.isContextConsumer = function(T) {
    return q(T) === i;
  }, H.isContextProvider = function(T) {
    return q(T) === v;
  }, H.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, H.isForwardRef = function(T) {
    return q(T) === g;
  }, H.isFragment = function(T) {
    return q(T) === r;
  }, H.isLazy = function(T) {
    return q(T) === I;
  }, H.isMemo = function(T) {
    return q(T) === D;
  }, H.isPortal = function(T) {
    return q(T) === n;
  }, H.isProfiler = function(T) {
    return q(T) === s;
  }, H.isStrictMode = function(T) {
    return q(T) === a;
  }, H.isSuspense = function(T) {
    return q(T) === h;
  }, H.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === r || T === m || T === s || T === a || T === h || T === O || typeof T == "object" && T !== null && (T.$$typeof === I || T.$$typeof === D || T.$$typeof === v || T.$$typeof === i || T.$$typeof === g || T.$$typeof === Y || T.$$typeof === F || T.$$typeof === X || T.$$typeof === j);
  }, H.typeOf = q, H;
}
var V = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gr;
function Ln() {
  return gr || (gr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, v = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, _ = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, g = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, O = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, j = e ? Symbol.for("react.block") : 60121, Y = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, X = e ? Symbol.for("react.scope") : 60119;
    function q(w) {
      return typeof w == "string" || typeof w == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      w === r || w === m || w === s || w === a || w === h || w === O || typeof w == "object" && w !== null && (w.$$typeof === I || w.$$typeof === D || w.$$typeof === v || w.$$typeof === i || w.$$typeof === g || w.$$typeof === Y || w.$$typeof === F || w.$$typeof === X || w.$$typeof === j);
    }
    function G(w) {
      if (typeof w == "object" && w !== null) {
        var ne = w.$$typeof;
        switch (ne) {
          case t:
            var ue = w.type;
            switch (ue) {
              case _:
              case m:
              case r:
              case s:
              case a:
              case h:
                return ue;
              default:
                var be = ue && ue.$$typeof;
                switch (be) {
                  case i:
                  case g:
                  case I:
                  case D:
                  case v:
                    return be;
                  default:
                    return ne;
                }
            }
          case n:
            return ne;
        }
      }
    }
    var T = _, le = m, Te = i, Re = v, ye = t, De = g, ge = r, ce = I, re = D, x = n, A = s, k = a, l = h, M = !1;
    function z(w) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), d(w) || G(w) === _;
    }
    function d(w) {
      return G(w) === m;
    }
    function E(w) {
      return G(w) === i;
    }
    function u(w) {
      return G(w) === v;
    }
    function c(w) {
      return typeof w == "object" && w !== null && w.$$typeof === t;
    }
    function f(w) {
      return G(w) === g;
    }
    function y(w) {
      return G(w) === r;
    }
    function p(w) {
      return G(w) === I;
    }
    function S(w) {
      return G(w) === D;
    }
    function P(w) {
      return G(w) === n;
    }
    function N(w) {
      return G(w) === s;
    }
    function R(w) {
      return G(w) === a;
    }
    function J(w) {
      return G(w) === h;
    }
    V.AsyncMode = T, V.ConcurrentMode = le, V.ContextConsumer = Te, V.ContextProvider = Re, V.Element = ye, V.ForwardRef = De, V.Fragment = ge, V.Lazy = ce, V.Memo = re, V.Portal = x, V.Profiler = A, V.StrictMode = k, V.Suspense = l, V.isAsyncMode = z, V.isConcurrentMode = d, V.isContextConsumer = E, V.isContextProvider = u, V.isElement = c, V.isForwardRef = f, V.isFragment = y, V.isLazy = p, V.isMemo = S, V.isPortal = P, V.isProfiler = N, V.isStrictMode = R, V.isSuspense = J, V.isValidElementType = q, V.typeOf = G;
  }()), V;
}
var br;
function Ur() {
  return br || (br = 1, process.env.NODE_ENV === "production" ? ct.exports = kn() : ct.exports = Ln()), ct.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Dt, _r;
function Un() {
  if (_r) return Dt;
  _r = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var v = {}, i = 0; i < 10; i++)
        v["_" + String.fromCharCode(i)] = i;
      var _ = Object.getOwnPropertyNames(v).map(function(g) {
        return v[g];
      });
      if (_.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(g) {
        m[g] = g;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Dt = a() ? Object.assign : function(s, v) {
    for (var i, _ = r(s), m, g = 1; g < arguments.length; g++) {
      i = Object(arguments[g]);
      for (var h in i)
        t.call(i, h) && (_[h] = i[h]);
      if (e) {
        m = e(i);
        for (var O = 0; O < m.length; O++)
          n.call(i, m[O]) && (_[m[O]] = i[m[O]]);
      }
    }
    return _;
  }, Dt;
}
var xt, Or;
function Jt() {
  if (Or) return xt;
  Or = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return xt = e, xt;
}
var Mt, Er;
function qr() {
  return Er || (Er = 1, Mt = Function.call.bind(Object.prototype.hasOwnProperty)), Mt;
}
var Nt, Sr;
function qn() {
  if (Sr) return Nt;
  Sr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Jt(), n = {}, r = qr();
    e = function(s) {
      var v = "Warning: " + s;
      typeof console < "u" && console.error(v);
      try {
        throw new Error(v);
      } catch {
      }
    };
  }
  function a(s, v, i, _, m) {
    if (process.env.NODE_ENV !== "production") {
      for (var g in s)
        if (r(s, g)) {
          var h;
          try {
            if (typeof s[g] != "function") {
              var O = Error(
                (_ || "React class") + ": " + i + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw O.name = "Invariant Violation", O;
            }
            h = s[g](v, g, _, i, null, t);
          } catch (I) {
            h = I;
          }
          if (h && !(h instanceof Error) && e(
            (_ || "React class") + ": type specification of " + i + " `" + g + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var D = m ? m() : "";
            e(
              "Failed " + i + " type: " + h.message + (D ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Nt = a, Nt;
}
var At, wr;
function Yn() {
  if (wr) return At;
  wr = 1;
  var e = Ur(), t = Un(), n = Jt(), r = qr(), a = qn(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(i) {
    var _ = "Warning: " + i;
    typeof console < "u" && console.error(_);
    try {
      throw new Error(_);
    } catch {
    }
  });
  function v() {
    return null;
  }
  return At = function(i, _) {
    var m = typeof Symbol == "function" && Symbol.iterator, g = "@@iterator";
    function h(d) {
      var E = d && (m && d[m] || d[g]);
      if (typeof E == "function")
        return E;
    }
    var O = "<<anonymous>>", D = {
      array: F("array"),
      bigint: F("bigint"),
      bool: F("boolean"),
      func: F("function"),
      number: F("number"),
      object: F("object"),
      string: F("string"),
      symbol: F("symbol"),
      any: X(),
      arrayOf: q,
      element: G(),
      elementType: T(),
      instanceOf: le,
      node: De(),
      objectOf: Re,
      oneOf: Te,
      oneOfType: ye,
      shape: ce,
      exact: re
    };
    function I(d, E) {
      return d === E ? d !== 0 || 1 / d === 1 / E : d !== d && E !== E;
    }
    function j(d, E) {
      this.message = d, this.data = E && typeof E == "object" ? E : {}, this.stack = "";
    }
    j.prototype = Error.prototype;
    function Y(d) {
      if (process.env.NODE_ENV !== "production")
        var E = {}, u = 0;
      function c(y, p, S, P, N, R, J) {
        if (P = P || O, R = R || S, J !== n) {
          if (_) {
            var w = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw w.name = "Invariant Violation", w;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ne = P + ":" + S;
            !E[ne] && // Avoid spamming the console because they are often not actionable except for lib authors
            u < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + R + "` prop on `" + P + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), E[ne] = !0, u++);
          }
        }
        return p[S] == null ? y ? p[S] === null ? new j("The " + N + " `" + R + "` is marked as required " + ("in `" + P + "`, but its value is `null`.")) : new j("The " + N + " `" + R + "` is marked as required in " + ("`" + P + "`, but its value is `undefined`.")) : null : d(p, S, P, N, R);
      }
      var f = c.bind(null, !1);
      return f.isRequired = c.bind(null, !0), f;
    }
    function F(d) {
      function E(u, c, f, y, p, S) {
        var P = u[c], N = k(P);
        if (N !== d) {
          var R = l(P);
          return new j(
            "Invalid " + y + " `" + p + "` of type " + ("`" + R + "` supplied to `" + f + "`, expected ") + ("`" + d + "`."),
            { expectedType: d }
          );
        }
        return null;
      }
      return Y(E);
    }
    function X() {
      return Y(v);
    }
    function q(d) {
      function E(u, c, f, y, p) {
        if (typeof d != "function")
          return new j("Property `" + p + "` of component `" + f + "` has invalid PropType notation inside arrayOf.");
        var S = u[c];
        if (!Array.isArray(S)) {
          var P = k(S);
          return new j("Invalid " + y + " `" + p + "` of type " + ("`" + P + "` supplied to `" + f + "`, expected an array."));
        }
        for (var N = 0; N < S.length; N++) {
          var R = d(S, N, f, y, p + "[" + N + "]", n);
          if (R instanceof Error)
            return R;
        }
        return null;
      }
      return Y(E);
    }
    function G() {
      function d(E, u, c, f, y) {
        var p = E[u];
        if (!i(p)) {
          var S = k(p);
          return new j("Invalid " + f + " `" + y + "` of type " + ("`" + S + "` supplied to `" + c + "`, expected a single ReactElement."));
        }
        return null;
      }
      return Y(d);
    }
    function T() {
      function d(E, u, c, f, y) {
        var p = E[u];
        if (!e.isValidElementType(p)) {
          var S = k(p);
          return new j("Invalid " + f + " `" + y + "` of type " + ("`" + S + "` supplied to `" + c + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return Y(d);
    }
    function le(d) {
      function E(u, c, f, y, p) {
        if (!(u[c] instanceof d)) {
          var S = d.name || O, P = z(u[c]);
          return new j("Invalid " + y + " `" + p + "` of type " + ("`" + P + "` supplied to `" + f + "`, expected ") + ("instance of `" + S + "`."));
        }
        return null;
      }
      return Y(E);
    }
    function Te(d) {
      if (!Array.isArray(d))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), v;
      function E(u, c, f, y, p) {
        for (var S = u[c], P = 0; P < d.length; P++)
          if (I(S, d[P]))
            return null;
        var N = JSON.stringify(d, function(J, w) {
          var ne = l(w);
          return ne === "symbol" ? String(w) : w;
        });
        return new j("Invalid " + y + " `" + p + "` of value `" + String(S) + "` " + ("supplied to `" + f + "`, expected one of " + N + "."));
      }
      return Y(E);
    }
    function Re(d) {
      function E(u, c, f, y, p) {
        if (typeof d != "function")
          return new j("Property `" + p + "` of component `" + f + "` has invalid PropType notation inside objectOf.");
        var S = u[c], P = k(S);
        if (P !== "object")
          return new j("Invalid " + y + " `" + p + "` of type " + ("`" + P + "` supplied to `" + f + "`, expected an object."));
        for (var N in S)
          if (r(S, N)) {
            var R = d(S, N, f, y, p + "." + N, n);
            if (R instanceof Error)
              return R;
          }
        return null;
      }
      return Y(E);
    }
    function ye(d) {
      if (!Array.isArray(d))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), v;
      for (var E = 0; E < d.length; E++) {
        var u = d[E];
        if (typeof u != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + M(u) + " at index " + E + "."
          ), v;
      }
      function c(f, y, p, S, P) {
        for (var N = [], R = 0; R < d.length; R++) {
          var J = d[R], w = J(f, y, p, S, P, n);
          if (w == null)
            return null;
          w.data && r(w.data, "expectedType") && N.push(w.data.expectedType);
        }
        var ne = N.length > 0 ? ", expected one of type [" + N.join(", ") + "]" : "";
        return new j("Invalid " + S + " `" + P + "` supplied to " + ("`" + p + "`" + ne + "."));
      }
      return Y(c);
    }
    function De() {
      function d(E, u, c, f, y) {
        return x(E[u]) ? null : new j("Invalid " + f + " `" + y + "` supplied to " + ("`" + c + "`, expected a ReactNode."));
      }
      return Y(d);
    }
    function ge(d, E, u, c, f) {
      return new j(
        (d || "React class") + ": " + E + " type `" + u + "." + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + f + "`."
      );
    }
    function ce(d) {
      function E(u, c, f, y, p) {
        var S = u[c], P = k(S);
        if (P !== "object")
          return new j("Invalid " + y + " `" + p + "` of type `" + P + "` " + ("supplied to `" + f + "`, expected `object`."));
        for (var N in d) {
          var R = d[N];
          if (typeof R != "function")
            return ge(f, y, p, N, l(R));
          var J = R(S, N, f, y, p + "." + N, n);
          if (J)
            return J;
        }
        return null;
      }
      return Y(E);
    }
    function re(d) {
      function E(u, c, f, y, p) {
        var S = u[c], P = k(S);
        if (P !== "object")
          return new j("Invalid " + y + " `" + p + "` of type `" + P + "` " + ("supplied to `" + f + "`, expected `object`."));
        var N = t({}, u[c], d);
        for (var R in N) {
          var J = d[R];
          if (r(d, R) && typeof J != "function")
            return ge(f, y, p, R, l(J));
          if (!J)
            return new j(
              "Invalid " + y + " `" + p + "` key `" + R + "` supplied to `" + f + "`.\nBad object: " + JSON.stringify(u[c], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(d), null, "  ")
            );
          var w = J(S, R, f, y, p + "." + R, n);
          if (w)
            return w;
        }
        return null;
      }
      return Y(E);
    }
    function x(d) {
      switch (typeof d) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !d;
        case "object":
          if (Array.isArray(d))
            return d.every(x);
          if (d === null || i(d))
            return !0;
          var E = h(d);
          if (E) {
            var u = E.call(d), c;
            if (E !== d.entries) {
              for (; !(c = u.next()).done; )
                if (!x(c.value))
                  return !1;
            } else
              for (; !(c = u.next()).done; ) {
                var f = c.value;
                if (f && !x(f[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function A(d, E) {
      return d === "symbol" ? !0 : E ? E["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && E instanceof Symbol : !1;
    }
    function k(d) {
      var E = typeof d;
      return Array.isArray(d) ? "array" : d instanceof RegExp ? "object" : A(E, d) ? "symbol" : E;
    }
    function l(d) {
      if (typeof d > "u" || d === null)
        return "" + d;
      var E = k(d);
      if (E === "object") {
        if (d instanceof Date)
          return "date";
        if (d instanceof RegExp)
          return "regexp";
      }
      return E;
    }
    function M(d) {
      var E = l(d);
      switch (E) {
        case "array":
        case "object":
          return "an " + E;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + E;
        default:
          return E;
      }
    }
    function z(d) {
      return !d.constructor || !d.constructor.name ? O : d.constructor.name;
    }
    return D.checkPropTypes = a, D.resetWarningCache = a.resetWarningCache, D.PropTypes = D, D;
  }, At;
}
var It, Tr;
function Bn() {
  if (Tr) return It;
  Tr = 1;
  var e = Jt();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, It = function() {
    function r(v, i, _, m, g, h) {
      if (h !== e) {
        var O = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw O.name = "Invariant Violation", O;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, It;
}
if (process.env.NODE_ENV !== "production") {
  var Hn = Ur(), Vn = !0;
  Ut.exports = Yn()(Hn.isElement, Vn);
} else
  Ut.exports = Bn()();
var bt = Ut.exports, qt = { exports: {} }, Se = {}, Yt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = g;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var n = "none", r = "contents", a = /input|select|textarea|button|object|iframe/;
  function s(h, O) {
    return O.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    h.scrollWidth <= 0 && h.scrollHeight <= 0;
  }
  function v(h) {
    var O = h.offsetWidth <= 0 && h.offsetHeight <= 0;
    if (O && !h.innerHTML) return !0;
    try {
      var D = window.getComputedStyle(h), I = D.getPropertyValue("display");
      return O ? I !== r && s(h, D) : I === n;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function i(h) {
    for (var O = h, D = h.getRootNode && h.getRootNode(); O && O !== document.body; ) {
      if (D && O === D && (O = D.host.parentNode), v(O)) return !1;
      O = O.parentNode;
    }
    return !0;
  }
  function _(h, O) {
    var D = h.nodeName.toLowerCase(), I = a.test(D) && !h.disabled || D === "a" && h.href || O;
    return I && i(h);
  }
  function m(h) {
    var O = h.getAttribute("tabindex");
    O === null && (O = void 0);
    var D = isNaN(O);
    return (D || O >= 0) && _(h, !D);
  }
  function g(h) {
    var O = [].slice.call(h.querySelectorAll("*"), 0).reduce(function(D, I) {
      return D.concat(I.shadowRoot ? g(I.shadowRoot) : [I]);
    }, []);
    return O.filter(m);
  }
  e.exports = t.default;
})(Yt, Yt.exports);
var Yr = Yt.exports;
Object.defineProperty(Se, "__esModule", {
  value: !0
});
Se.resetState = Gn;
Se.log = Jn;
Se.handleBlur = ot;
Se.handleFocus = at;
Se.markForFocusLater = Zn;
Se.returnFocus = Qn;
Se.popWithoutFocus = eo;
Se.setupScopedFocus = to;
Se.teardownScopedFocus = ro;
var zn = Yr, Xn = Kn(zn);
function Kn(e) {
  return e && e.__esModule ? e : { default: e };
}
var Ye = [], ze = null, Bt = !1;
function Gn() {
  Ye = [];
}
function Jn() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), Ye.forEach(function(e) {
    var t = e || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function ot() {
  Bt = !0;
}
function at() {
  if (Bt) {
    if (Bt = !1, !ze)
      return;
    setTimeout(function() {
      if (!ze.contains(document.activeElement)) {
        var e = (0, Xn.default)(ze)[0] || ze;
        e.focus();
      }
    }, 0);
  }
}
function Zn() {
  Ye.push(document.activeElement);
}
function Qn() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    Ye.length !== 0 && (t = Ye.pop(), t.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function eo() {
  Ye.length > 0 && Ye.pop();
}
function to(e) {
  ze = e, window.addEventListener ? (window.addEventListener("blur", ot, !1), document.addEventListener("focus", at, !0)) : (window.attachEvent("onBlur", ot), document.attachEvent("onFocus", at));
}
function ro() {
  ze = null, window.addEventListener ? (window.removeEventListener("blur", ot), document.removeEventListener("focus", at)) : (window.detachEvent("onBlur", ot), document.detachEvent("onFocus", at));
}
var Ht = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var n = Yr, r = a(n);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function s() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return i.activeElement.shadowRoot ? s(i.activeElement.shadowRoot) : i.activeElement;
  }
  function v(i, _) {
    var m = (0, r.default)(i);
    if (!m.length) {
      _.preventDefault();
      return;
    }
    var g = void 0, h = _.shiftKey, O = m[0], D = m[m.length - 1], I = s();
    if (i === I) {
      if (!h) return;
      g = D;
    }
    if (D === I && !h && (g = O), O === I && h && (g = D), g) {
      _.preventDefault(), g.focus();
      return;
    }
    var j = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), Y = j != null && j[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (Y) {
      var F = m.indexOf(I);
      if (F > -1 && (F += h ? -1 : 1), g = m[F], typeof g > "u") {
        _.preventDefault(), g = h ? D : O, g.focus();
        return;
      }
      _.preventDefault(), g.focus();
    }
  }
  e.exports = t.default;
})(Ht, Ht.exports);
var no = Ht.exports, we = {}, oo = process.env.NODE_ENV !== "production", Br = function() {
};
if (oo) {
  var ao = function(t, n) {
    var r = arguments.length;
    n = new Array(r > 1 ? r - 1 : 0);
    for (var a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    var s = 0, v = "Warning: " + t.replace(/%s/g, function() {
      return n[s++];
    });
    typeof console < "u" && console.error(v);
    try {
      throw new Error(v);
    } catch {
    }
  };
  Br = function(e, t, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var a = 2; a < r; a++)
      n[a - 2] = arguments[a];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || ao.apply(null, [t].concat(n));
  };
}
var io = Br, Ee = {}, Hr = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), n = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    e.exports ? e.exports = n : window.ExecutionEnvironment = n;
  })();
})(Hr);
var so = Hr.exports;
Object.defineProperty(Ee, "__esModule", {
  value: !0
});
Ee.canUseDOM = Ee.SafeNodeList = Ee.SafeHTMLCollection = void 0;
var uo = so, lo = co(uo);
function co(e) {
  return e && e.__esModule ? e : { default: e };
}
var _t = lo.default, fo = _t.canUseDOM ? window.HTMLElement : {};
Ee.SafeHTMLCollection = _t.canUseDOM ? window.HTMLCollection : {};
Ee.SafeNodeList = _t.canUseDOM ? window.NodeList : {};
Ee.canUseDOM = _t.canUseDOM;
Ee.default = fo;
Object.defineProperty(we, "__esModule", {
  value: !0
});
we.resetState = ho;
we.log = go;
we.assertNodeList = Vr;
we.setElement = bo;
we.validateElement = Zt;
we.hide = _o;
we.show = Oo;
we.documentNotReadyOrSSRTesting = Eo;
var po = io, vo = mo(po), yo = Ee;
function mo(e) {
  return e && e.__esModule ? e : { default: e };
}
var pe = null;
function ho() {
  pe && (pe.removeAttribute ? pe.removeAttribute("aria-hidden") : pe.length != null ? pe.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(pe).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), pe = null;
}
function go() {
  if (process.env.NODE_ENV !== "production") {
    var e = pe || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function Vr(e, t) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function bo(e) {
  var t = e;
  if (typeof t == "string" && yo.canUseDOM) {
    var n = document.querySelectorAll(t);
    Vr(n, t), t = n;
  }
  return pe = t || pe, pe;
}
function Zt(e) {
  var t = e || pe;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, vo.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function _o(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var a = Zt(e)[Symbol.iterator](), s; !(t = (s = a.next()).done); t = !0) {
      var v = s.value;
      v.setAttribute("aria-hidden", "true");
    }
  } catch (i) {
    n = !0, r = i;
  } finally {
    try {
      !t && a.return && a.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function Oo(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var a = Zt(e)[Symbol.iterator](), s; !(t = (s = a.next()).done); t = !0) {
      var v = s.value;
      v.removeAttribute("aria-hidden");
    }
  } catch (i) {
    n = !0, r = i;
  } finally {
    try {
      !t && a.return && a.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function Eo() {
  pe = null;
}
var Ge = {};
Object.defineProperty(Ge, "__esModule", {
  value: !0
});
Ge.resetState = So;
Ge.log = wo;
var ke = {}, Le = {};
function Cr(e, t) {
  e.classList.remove(t);
}
function So() {
  var e = document.getElementsByTagName("html")[0];
  for (var t in ke)
    Cr(e, ke[t]);
  var n = document.body;
  for (var r in Le)
    Cr(n, Le[r]);
  ke = {}, Le = {};
}
function wo() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + e + `):
  `;
    for (var n in ke)
      t += "  " + n + " " + ke[n] + `
  `;
    e = document.body.className, t += `

doc.body (` + e + `):
  `;
    for (var r in Le)
      t += "  " + r + " " + Le[r] + `
  `;
    t += `
`, console.log(t);
  }
}
var To = function(t, n) {
  return t[n] || (t[n] = 0), t[n] += 1, n;
}, Co = function(t, n) {
  return t[n] && (t[n] -= 1), n;
}, Po = function(t, n, r) {
  r.forEach(function(a) {
    To(n, a), t.add(a);
  });
}, Ro = function(t, n, r) {
  r.forEach(function(a) {
    Co(n, a), n[a] === 0 && t.remove(a);
  });
};
Ge.add = function(t, n) {
  return Po(t.classList, t.nodeName.toLowerCase() == "html" ? ke : Le, n.split(" "));
};
Ge.remove = function(t, n) {
  return Ro(t.classList, t.nodeName.toLowerCase() == "html" ? ke : Le, n.split(" "));
};
var Je = {};
Object.defineProperty(Je, "__esModule", {
  value: !0
});
Je.log = xo;
Je.resetState = Mo;
function Do(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var zr = function e() {
  var t = this;
  Do(this, e), this.register = function(n) {
    if (t.openInstances.indexOf(n) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(n), t.emit("register");
  }, this.deregister = function(n) {
    var r = t.openInstances.indexOf(n);
    if (r === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + n + " as it was never registered");
      return;
    }
    t.openInstances.splice(r, 1), t.emit("deregister");
  }, this.subscribe = function(n) {
    t.subscribers.push(n);
  }, this.emit = function(n) {
    t.subscribers.forEach(function(r) {
      return r(
        n,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, vt = new zr();
function xo() {
  console.log("portalOpenInstances ----------"), console.log(vt.openInstances.length), vt.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function Mo() {
  vt = new zr();
}
Je.default = vt;
var Qt = {};
Object.defineProperty(Qt, "__esModule", {
  value: !0
});
Qt.resetState = jo;
Qt.log = Wo;
var No = Je, Ao = Io(No);
function Io(e) {
  return e && e.__esModule ? e : { default: e };
}
var ie = void 0, Oe = void 0, Ue = [];
function jo() {
  for (var e = [ie, Oe], t = 0; t < e.length; t++) {
    var n = e[t];
    n && n.parentNode && n.parentNode.removeChild(n);
  }
  ie = Oe = null, Ue = [];
}
function Wo() {
  console.log("bodyTrap ----------"), console.log(Ue.length);
  for (var e = [ie, Oe], t = 0; t < e.length; t++) {
    var n = e[t], r = n || {};
    console.log(r.nodeName, r.className, r.id);
  }
  console.log("edn bodyTrap ----------");
}
function Pr() {
  if (Ue.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  Ue[Ue.length - 1].focusContent();
}
function $o(e, t) {
  !ie && !Oe && (ie = document.createElement("div"), ie.setAttribute("data-react-modal-body-trap", ""), ie.style.position = "absolute", ie.style.opacity = "0", ie.setAttribute("tabindex", "0"), ie.addEventListener("focus", Pr), Oe = ie.cloneNode(), Oe.addEventListener("focus", Pr)), Ue = t, Ue.length > 0 ? (document.body.firstChild !== ie && document.body.insertBefore(ie, document.body.firstChild), document.body.lastChild !== Oe && document.body.appendChild(Oe)) : (ie.parentElement && ie.parentElement.removeChild(ie), Oe.parentElement && Oe.parentElement.removeChild(Oe));
}
Ao.default.subscribe($o);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(x) {
    for (var A = 1; A < arguments.length; A++) {
      var k = arguments[A];
      for (var l in k)
        Object.prototype.hasOwnProperty.call(k, l) && (x[l] = k[l]);
    }
    return x;
  }, r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
    return typeof x;
  } : function(x) {
    return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
  }, a = /* @__PURE__ */ function() {
    function x(A, k) {
      for (var l = 0; l < k.length; l++) {
        var M = k[l];
        M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(A, M.key, M);
      }
    }
    return function(A, k, l) {
      return k && x(A.prototype, k), l && x(A, l), A;
    };
  }(), s = Ke, v = bt, i = T(v), _ = Se, m = G(_), g = no, h = T(g), O = we, D = G(O), I = Ge, j = G(I), Y = Ee, F = T(Y), X = Je, q = T(X);
  function G(x) {
    if (x && x.__esModule)
      return x;
    var A = {};
    if (x != null)
      for (var k in x)
        Object.prototype.hasOwnProperty.call(x, k) && (A[k] = x[k]);
    return A.default = x, A;
  }
  function T(x) {
    return x && x.__esModule ? x : { default: x };
  }
  function le(x, A) {
    if (!(x instanceof A))
      throw new TypeError("Cannot call a class as a function");
  }
  function Te(x, A) {
    if (!x)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return A && (typeof A == "object" || typeof A == "function") ? A : x;
  }
  function Re(x, A) {
    if (typeof A != "function" && A !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof A);
    x.prototype = Object.create(A && A.prototype, { constructor: { value: x, enumerable: !1, writable: !0, configurable: !0 } }), A && (Object.setPrototypeOf ? Object.setPrototypeOf(x, A) : x.__proto__ = A);
  }
  var ye = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, De = function(A) {
    return A.code === "Tab" || A.keyCode === 9;
  }, ge = function(A) {
    return A.code === "Escape" || A.keyCode === 27;
  }, ce = 0, re = function(x) {
    Re(A, x);
    function A(k) {
      le(this, A);
      var l = Te(this, (A.__proto__ || Object.getPrototypeOf(A)).call(this, k));
      return l.setOverlayRef = function(M) {
        l.overlay = M, l.props.overlayRef && l.props.overlayRef(M);
      }, l.setContentRef = function(M) {
        l.content = M, l.props.contentRef && l.props.contentRef(M);
      }, l.afterClose = function() {
        var M = l.props, z = M.appElement, d = M.ariaHideApp, E = M.htmlOpenClassName, u = M.bodyOpenClassName, c = M.parentSelector, f = c && c().ownerDocument || document;
        u && j.remove(f.body, u), E && j.remove(f.getElementsByTagName("html")[0], E), d && ce > 0 && (ce -= 1, ce === 0 && D.show(z)), l.props.shouldFocusAfterRender && (l.props.shouldReturnFocusAfterClose ? (m.returnFocus(l.props.preventScroll), m.teardownScopedFocus()) : m.popWithoutFocus()), l.props.onAfterClose && l.props.onAfterClose(), q.default.deregister(l);
      }, l.open = function() {
        l.beforeOpen(), l.state.afterOpen && l.state.beforeClose ? (clearTimeout(l.closeTimer), l.setState({ beforeClose: !1 })) : (l.props.shouldFocusAfterRender && (m.setupScopedFocus(l.node), m.markForFocusLater()), l.setState({ isOpen: !0 }, function() {
          l.openAnimationFrame = requestAnimationFrame(function() {
            l.setState({ afterOpen: !0 }), l.props.isOpen && l.props.onAfterOpen && l.props.onAfterOpen({
              overlayEl: l.overlay,
              contentEl: l.content
            });
          });
        }));
      }, l.close = function() {
        l.props.closeTimeoutMS > 0 ? l.closeWithTimeout() : l.closeWithoutTimeout();
      }, l.focusContent = function() {
        return l.content && !l.contentHasFocus() && l.content.focus({ preventScroll: !0 });
      }, l.closeWithTimeout = function() {
        var M = Date.now() + l.props.closeTimeoutMS;
        l.setState({ beforeClose: !0, closesAt: M }, function() {
          l.closeTimer = setTimeout(l.closeWithoutTimeout, l.state.closesAt - Date.now());
        });
      }, l.closeWithoutTimeout = function() {
        l.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, l.afterClose);
      }, l.handleKeyDown = function(M) {
        De(M) && (0, h.default)(l.content, M), l.props.shouldCloseOnEsc && ge(M) && (M.stopPropagation(), l.requestClose(M));
      }, l.handleOverlayOnClick = function(M) {
        l.shouldClose === null && (l.shouldClose = !0), l.shouldClose && l.props.shouldCloseOnOverlayClick && (l.ownerHandlesClose() ? l.requestClose(M) : l.focusContent()), l.shouldClose = null;
      }, l.handleContentOnMouseUp = function() {
        l.shouldClose = !1;
      }, l.handleOverlayOnMouseDown = function(M) {
        !l.props.shouldCloseOnOverlayClick && M.target == l.overlay && M.preventDefault();
      }, l.handleContentOnClick = function() {
        l.shouldClose = !1;
      }, l.handleContentOnMouseDown = function() {
        l.shouldClose = !1;
      }, l.requestClose = function(M) {
        return l.ownerHandlesClose() && l.props.onRequestClose(M);
      }, l.ownerHandlesClose = function() {
        return l.props.onRequestClose;
      }, l.shouldBeClosed = function() {
        return !l.state.isOpen && !l.state.beforeClose;
      }, l.contentHasFocus = function() {
        return document.activeElement === l.content || l.content.contains(document.activeElement);
      }, l.buildClassName = function(M, z) {
        var d = (typeof z > "u" ? "undefined" : r(z)) === "object" ? z : {
          base: ye[M],
          afterOpen: ye[M] + "--after-open",
          beforeClose: ye[M] + "--before-close"
        }, E = d.base;
        return l.state.afterOpen && (E = E + " " + d.afterOpen), l.state.beforeClose && (E = E + " " + d.beforeClose), typeof z == "string" && z ? E + " " + z : E;
      }, l.attributesFromObject = function(M, z) {
        return Object.keys(z).reduce(function(d, E) {
          return d[M + "-" + E] = z[E], d;
        }, {});
      }, l.state = {
        afterOpen: !1,
        beforeClose: !1
      }, l.shouldClose = null, l.moveFromContentToOverlay = null, l;
    }
    return a(A, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(l, M) {
        process.env.NODE_ENV !== "production" && (l.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), l.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !l.isOpen ? this.open() : !this.props.isOpen && l.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !M.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var l = this.props, M = l.appElement, z = l.ariaHideApp, d = l.htmlOpenClassName, E = l.bodyOpenClassName, u = l.parentSelector, c = u && u().ownerDocument || document;
        E && j.add(c.body, E), d && j.add(c.getElementsByTagName("html")[0], d), z && (ce += 1, D.hide(M)), q.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var l = this.props, M = l.id, z = l.className, d = l.overlayClassName, E = l.defaultStyles, u = l.children, c = z ? {} : E.content, f = d ? {} : E.overlay;
        if (this.shouldBeClosed())
          return null;
        var y = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", d),
          style: n({}, f, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, p = n({
          id: M,
          ref: this.setContentRef,
          style: n({}, c, this.props.style.content),
          className: this.buildClassName("content", z),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", n({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), S = this.props.contentElement(p, u);
        return this.props.overlayElement(y, S);
      }
    }]), A;
  }(s.Component);
  re.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, re.propTypes = {
    isOpen: i.default.bool.isRequired,
    defaultStyles: i.default.shape({
      content: i.default.object,
      overlay: i.default.object
    }),
    style: i.default.shape({
      content: i.default.object,
      overlay: i.default.object
    }),
    className: i.default.oneOfType([i.default.string, i.default.object]),
    overlayClassName: i.default.oneOfType([i.default.string, i.default.object]),
    parentSelector: i.default.func,
    bodyOpenClassName: i.default.string,
    htmlOpenClassName: i.default.string,
    ariaHideApp: i.default.bool,
    appElement: i.default.oneOfType([i.default.instanceOf(F.default), i.default.instanceOf(Y.SafeHTMLCollection), i.default.instanceOf(Y.SafeNodeList), i.default.arrayOf(i.default.instanceOf(F.default))]),
    onAfterOpen: i.default.func,
    onAfterClose: i.default.func,
    onRequestClose: i.default.func,
    closeTimeoutMS: i.default.number,
    shouldFocusAfterRender: i.default.bool,
    shouldCloseOnOverlayClick: i.default.bool,
    shouldReturnFocusAfterClose: i.default.bool,
    preventScroll: i.default.bool,
    role: i.default.string,
    contentLabel: i.default.string,
    aria: i.default.object,
    data: i.default.object,
    children: i.default.node,
    shouldCloseOnEsc: i.default.bool,
    overlayRef: i.default.func,
    contentRef: i.default.func,
    id: i.default.string,
    overlayElement: i.default.func,
    contentElement: i.default.func,
    testId: i.default.string
  }, t.default = re, e.exports = t.default;
})(qt, qt.exports);
var Fo = qt.exports;
function Xr() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Kr(e) {
  function t(n) {
    var r = this.constructor.getDerivedStateFromProps(e, n);
    return r ?? null;
  }
  this.setState(t.bind(this));
}
function Gr(e, t) {
  try {
    var n = this.props, r = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      r
    );
  } finally {
    this.props = n, this.state = r;
  }
}
Xr.__suppressDeprecationWarning = !0;
Kr.__suppressDeprecationWarning = !0;
Gr.__suppressDeprecationWarning = !0;
function ko(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var n = null, r = null, a = null;
  if (typeof t.componentWillMount == "function" ? n = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? r = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (r = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? a = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (a = "UNSAFE_componentWillUpdate"), n !== null || r !== null || a !== null) {
    var s = e.displayName || e.name, v = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + s + " uses " + v + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + (a !== null ? `
  ` + a : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = Xr, t.componentWillReceiveProps = Kr), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = Gr;
    var i = t.componentDidUpdate;
    t.componentDidUpdate = function(m, g, h) {
      var O = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : h;
      i.call(this, m, g, O);
    };
  }
  return e;
}
const Lo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: ko
}, Symbol.toStringTag, { value: "Module" })), Uo = /* @__PURE__ */ Lr(Lo);
Object.defineProperty(qe, "__esModule", {
  value: !0
});
qe.bodyOpenClassName = qe.portalClassName = void 0;
var Rr = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, qo = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var a = n[r];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}(), Jr = Ke, yt = it(Jr), Yo = Kt, mt = it(Yo), Bo = bt, $ = it(Bo), Ho = Fo, Dr = it(Ho), Vo = we, zo = Ko(Vo), je = Ee, xr = it(je), Xo = Uo;
function Ko(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t.default = e, t;
}
function it(e) {
  return e && e.__esModule ? e : { default: e };
}
function Go(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Mr(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Jo(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Zo = qe.portalClassName = "ReactModalPortal", Qo = qe.bodyOpenClassName = "ReactModal__Body--open", Fe = je.canUseDOM && mt.default.createPortal !== void 0, Vt = function(t) {
  return document.createElement(t);
}, Nr = function() {
  return Fe ? mt.default.createPortal : mt.default.unstable_renderSubtreeIntoContainer;
};
function ft(e) {
  return e();
}
var Ze = function(e) {
  Jo(t, e);
  function t() {
    var n, r, a, s;
    Go(this, t);
    for (var v = arguments.length, i = Array(v), _ = 0; _ < v; _++)
      i[_] = arguments[_];
    return s = (r = (a = Mr(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(i))), a), a.removePortal = function() {
      !Fe && mt.default.unmountComponentAtNode(a.node);
      var m = ft(a.props.parentSelector);
      m && m.contains(a.node) ? m.removeChild(a.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, a.portalRef = function(m) {
      a.portal = m;
    }, a.renderPortal = function(m) {
      var g = Nr(), h = g(a, yt.default.createElement(Dr.default, Rr({ defaultStyles: t.defaultStyles }, m)), a.node);
      a.portalRef(h);
    }, r), Mr(a, s);
  }
  return qo(t, [{
    key: "componentDidMount",
    value: function() {
      if (je.canUseDOM) {
        Fe || (this.node = Vt("div")), this.node.className = this.props.portalClassName;
        var r = ft(this.props.parentSelector);
        r.appendChild(this.node), !Fe && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(r) {
      var a = ft(r.parentSelector), s = ft(this.props.parentSelector);
      return { prevParent: a, nextParent: s };
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, a, s) {
      if (je.canUseDOM) {
        var v = this.props, i = v.isOpen, _ = v.portalClassName;
        r.portalClassName !== _ && (this.node.className = _);
        var m = s.prevParent, g = s.nextParent;
        g !== m && (m.removeChild(this.node), g.appendChild(this.node)), !(!r.isOpen && !i) && !Fe && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!je.canUseDOM || !this.node || !this.portal)) {
        var r = this.portal.state, a = Date.now(), s = r.isOpen && this.props.closeTimeoutMS && (r.closesAt || a + this.props.closeTimeoutMS);
        s ? (r.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, s - a)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!je.canUseDOM || !Fe)
        return null;
      !this.node && Fe && (this.node = Vt("div"));
      var r = Nr();
      return r(yt.default.createElement(Dr.default, Rr({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(r) {
      zo.setElement(r);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(Jr.Component);
Ze.propTypes = {
  isOpen: $.default.bool.isRequired,
  style: $.default.shape({
    content: $.default.object,
    overlay: $.default.object
  }),
  portalClassName: $.default.string,
  bodyOpenClassName: $.default.string,
  htmlOpenClassName: $.default.string,
  className: $.default.oneOfType([$.default.string, $.default.shape({
    base: $.default.string.isRequired,
    afterOpen: $.default.string.isRequired,
    beforeClose: $.default.string.isRequired
  })]),
  overlayClassName: $.default.oneOfType([$.default.string, $.default.shape({
    base: $.default.string.isRequired,
    afterOpen: $.default.string.isRequired,
    beforeClose: $.default.string.isRequired
  })]),
  appElement: $.default.oneOfType([$.default.instanceOf(xr.default), $.default.instanceOf(je.SafeHTMLCollection), $.default.instanceOf(je.SafeNodeList), $.default.arrayOf($.default.instanceOf(xr.default))]),
  onAfterOpen: $.default.func,
  onRequestClose: $.default.func,
  closeTimeoutMS: $.default.number,
  ariaHideApp: $.default.bool,
  shouldFocusAfterRender: $.default.bool,
  shouldCloseOnOverlayClick: $.default.bool,
  shouldReturnFocusAfterClose: $.default.bool,
  preventScroll: $.default.bool,
  parentSelector: $.default.func,
  aria: $.default.object,
  data: $.default.object,
  role: $.default.string,
  contentLabel: $.default.string,
  shouldCloseOnEsc: $.default.bool,
  overlayRef: $.default.func,
  contentRef: $.default.func,
  id: $.default.string,
  overlayElement: $.default.func,
  contentElement: $.default.func
};
Ze.defaultProps = {
  isOpen: !1,
  portalClassName: Zo,
  bodyOpenClassName: Qo,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, n) {
    return yt.default.createElement(
      "div",
      t,
      n
    );
  },
  contentElement: function(t, n) {
    return yt.default.createElement(
      "div",
      t,
      n
    );
  }
};
Ze.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, Xo.polyfill)(Ze);
process.env.NODE_ENV !== "production" && (Ze.setCreateHTMLElement = function(e) {
  return Vt = e;
});
qe.default = Ze;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = qe, r = a(n);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  t.default = r.default, e.exports = t.default;
})(Lt, Lt.exports);
var ea = Lt.exports;
const ta = /* @__PURE__ */ Gt(ea), ra = {
  SHORT: 50,
  LONG: 100
};
function jt(e, t) {
  return { ...t ? { "data-testid": `${t}-${e}` } : {} };
}
const na = "_htmlOpen_1cowi_1", oa = "_content_1cowi_5", aa = "_errorIcon_1cowi_29", ia = "_successIcon_1cowi_34", sa = "_informalIcon_1cowi_39", ua = "_warningIcon_1cowi_44", la = "_headerWrapper_1cowi_49", ca = "_header_1cowi_49", fa = "_overlay_1cowi_68", da = "_closeButton_1cowi_79", pa = "_footerWrapper_1cowi_88", Ne = {
  htmlOpen: na,
  content: oa,
  errorIcon: aa,
  successIcon: ia,
  informalIcon: sa,
  warningIcon: ua,
  headerWrapper: la,
  header: ca,
  overlay: fa,
  closeButton: da,
  footerWrapper: pa
}, va = {
  error: "WarningBoldStroke",
  success: "CheckInCircleBoldStroke",
  informal: "InformationInCircleBoldStroke",
  warning: "AlertInCircleBoldStroke"
}, ya = {
  normal: "neutral",
  error: "danger",
  success: "success",
  informal: "informal",
  warning: "warning"
}, Ti = ({
  isOpen: e,
  title: t,
  children: n,
  onClose: r,
  onCancel: a,
  onOk: s,
  rootElementId: v,
  cancelText: i = "Cancel",
  okText: _ = "OK",
  okButtonProps: m,
  cancelButtonProps: g,
  type: h = "normal",
  footer: O,
  closeable: D = !0
}) => {
  const I = /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    D && /* @__PURE__ */ Z.jsx(
      vr,
      {
        testId: "modal-cancel",
        ...g,
        fullWidth: !0,
        size: "large",
        variant: "secondary",
        onClick: a,
        children: i
      }
    ),
    /* @__PURE__ */ Z.jsx(
      vr,
      {
        testId: "modal-ok",
        ...m,
        fullWidth: !0,
        size: "large",
        colorType: ya[h],
        onClick: s,
        children: _
      }
    )
  ] });
  return /* @__PURE__ */ Z.jsxs(
    ta,
    {
      closeTimeoutMS: ra.SHORT,
      isOpen: e,
      overlayClassName: Ne.overlay,
      className: Ne.content,
      htmlOpenClassName: Ne.htmlOpen,
      appElement: document.getElementById(v),
      children: [
        /* @__PURE__ */ Z.jsxs("header", { className: Ne.headerWrapper, children: [
          h !== "normal" && /* @__PURE__ */ Z.jsx("span", { className: Ne[`${h}Icon`], children: /* @__PURE__ */ Z.jsx(kr, { icon: va[h], size: 40 }) }),
          /* @__PURE__ */ Z.jsx("h2", { className: Ne.header, children: t }),
          D && /* @__PURE__ */ Z.jsx("div", { className: Ne.closeButton, children: /* @__PURE__ */ Z.jsx(
            jn,
            {
              testId: "modal-close",
              leftIcon: "CloseBoldStroke",
              onClick: r,
              size: "medium",
              "aria-label": "close modal"
            }
          ) })
        ] }),
        /* @__PURE__ */ Z.jsx("section", { className: Ne.contentWrapper, children: n }),
        /* @__PURE__ */ Z.jsx("footer", { className: Ne.footerWrapper, children: O === void 0 ? I : O })
      ]
    }
  );
};
var Zr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var s = "", v = 0; v < arguments.length; v++) {
        var i = arguments[v];
        i && (s = a(s, r(i)));
      }
      return s;
    }
    function r(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return n.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var v = "";
      for (var i in s)
        t.call(s, i) && s[i] && (v = a(v, i));
      return v;
    }
    function a(s, v) {
      return v ? s ? s + " " + v : s + v : s;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Zr);
var ma = Zr.exports;
const ha = /* @__PURE__ */ Gt(ma);
var Ot = { exports: {} }, Qr = {};
function en(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = en(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function Ar() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = en(e)) && (r && (r += " "), r += t);
  return r;
}
const ga = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: Ar,
  default: Ar
}, Symbol.toStringTag, { value: "Module" })), ba = /* @__PURE__ */ Lr(ga);
var Q = {}, Ce = {};
Object.defineProperty(Ce, "__esModule", {
  value: !0
});
Ce.dontSetMe = wa;
Ce.findInArray = _a;
Ce.int = Sa;
Ce.isFunction = Oa;
Ce.isNum = Ea;
function _a(e, t) {
  for (var n = 0, r = e.length; n < r; n++)
    if (t.apply(t, [e[n], n, e])) return e[n];
}
function Oa(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Function]";
}
function Ea(e) {
  return typeof e == "number" && !isNaN(e);
}
function Sa(e) {
  return parseInt(e, 10);
}
function wa(e, t, n) {
  if (e[t])
    return new Error("Invalid prop ".concat(t, " passed to ").concat(n, " - do not set this, set it on the child."));
}
var Be = {};
Object.defineProperty(Be, "__esModule", {
  value: !0
});
Be.browserPrefixToKey = rn;
Be.browserPrefixToStyle = Ta;
Be.default = void 0;
Be.getPrefix = tn;
var Wt = ["Moz", "Webkit", "O", "ms"];
function tn() {
  var e, t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u") return "";
  var r = (e = window.document) === null || e === void 0 || (t = e.documentElement) === null || t === void 0 ? void 0 : t.style;
  if (!r || n in r) return "";
  for (var a = 0; a < Wt.length; a++)
    if (rn(n, Wt[a]) in r) return Wt[a];
  return "";
}
function rn(e, t) {
  return t ? "".concat(t).concat(Ca(e)) : e;
}
function Ta(e, t) {
  return t ? "-".concat(t.toLowerCase(), "-").concat(e) : e;
}
function Ca(e) {
  for (var t = "", n = !0, r = 0; r < e.length; r++)
    n ? (t += e[r].toUpperCase(), n = !1) : e[r] === "-" ? n = !0 : t += e[r];
  return t;
}
var Pa = tn();
Be.default = Pa;
function zt(e) {
  "@babel/helpers - typeof";
  return zt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zt(e);
}
Object.defineProperty(Q, "__esModule", {
  value: !0
});
Q.addClassName = un;
Q.addEvent = xa;
Q.addUserSelectStyles = Ua;
Q.createCSSTransform = $a;
Q.createSVGTransform = Fa;
Q.getTouch = ka;
Q.getTouchIdentifier = La;
Q.getTranslation = er;
Q.innerHeight = Ia;
Q.innerWidth = ja;
Q.matchesSelector = sn;
Q.matchesSelectorAndParentsTo = Da;
Q.offsetXYFromParent = Wa;
Q.outerHeight = Na;
Q.outerWidth = Aa;
Q.removeClassName = ln;
Q.removeEvent = Ma;
Q.removeUserSelectStyles = qa;
var ve = Ce, Ir = Ra(Be);
function nn(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (nn = function(a) {
    return a ? n : t;
  })(e);
}
function Ra(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || zt(e) !== "object" && typeof e != "function")
    return { default: e };
  var n = nn(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
      var v = a ? Object.getOwnPropertyDescriptor(e, s) : null;
      v && (v.get || v.set) ? Object.defineProperty(r, s, v) : r[s] = e[s];
    }
  return r.default = e, n && n.set(e, r), r;
}
function jr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function on(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jr(Object(n), !0).forEach(function(r) {
      an(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jr(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function an(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var dt = "";
function sn(e, t) {
  return dt || (dt = (0, ve.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(n) {
    return (0, ve.isFunction)(e[n]);
  })), (0, ve.isFunction)(e[dt]) ? e[dt](t) : !1;
}
function Da(e, t, n) {
  var r = e;
  do {
    if (sn(r, t)) return !0;
    if (r === n) return !1;
    r = r.parentNode;
  } while (r);
  return !1;
}
function xa(e, t, n, r) {
  if (e) {
    var a = on({
      capture: !0
    }, r);
    e.addEventListener ? e.addEventListener(t, n, a) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
  }
}
function Ma(e, t, n, r) {
  if (e) {
    var a = on({
      capture: !0
    }, r);
    e.removeEventListener ? e.removeEventListener(t, n, a) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
  }
}
function Na(e) {
  var t = e.clientHeight, n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, ve.int)(n.borderTopWidth), t += (0, ve.int)(n.borderBottomWidth), t;
}
function Aa(e) {
  var t = e.clientWidth, n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, ve.int)(n.borderLeftWidth), t += (0, ve.int)(n.borderRightWidth), t;
}
function Ia(e) {
  var t = e.clientHeight, n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, ve.int)(n.paddingTop), t -= (0, ve.int)(n.paddingBottom), t;
}
function ja(e) {
  var t = e.clientWidth, n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, ve.int)(n.paddingLeft), t -= (0, ve.int)(n.paddingRight), t;
}
function Wa(e, t, n) {
  var r = t === t.ownerDocument.body, a = r ? {
    left: 0,
    top: 0
  } : t.getBoundingClientRect(), s = (e.clientX + t.scrollLeft - a.left) / n, v = (e.clientY + t.scrollTop - a.top) / n;
  return {
    x: s,
    y: v
  };
}
function $a(e, t) {
  var n = er(e, t, "px");
  return an({}, (0, Ir.browserPrefixToKey)("transform", Ir.default), n);
}
function Fa(e, t) {
  var n = er(e, t, "");
  return n;
}
function er(e, t, n) {
  var r = e.x, a = e.y, s = "translate(".concat(r).concat(n, ",").concat(a).concat(n, ")");
  if (t) {
    var v = "".concat(typeof t.x == "string" ? t.x : t.x + n), i = "".concat(typeof t.y == "string" ? t.y : t.y + n);
    s = "translate(".concat(v, ", ").concat(i, ")") + s;
  }
  return s;
}
function ka(e, t) {
  return e.targetTouches && (0, ve.findInArray)(e.targetTouches, function(n) {
    return t === n.identifier;
  }) || e.changedTouches && (0, ve.findInArray)(e.changedTouches, function(n) {
    return t === n.identifier;
  });
}
function La(e) {
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
function Ua(e) {
  if (e) {
    var t = e.getElementById("react-draggable-style-el");
    t || (t = e.createElement("style"), t.type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, t.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, e.getElementsByTagName("head")[0].appendChild(t)), e.body && un(e.body, "react-draggable-transparent-selection");
  }
}
function qa(e) {
  if (e)
    try {
      if (e.body && ln(e.body, "react-draggable-transparent-selection"), e.selection)
        e.selection.empty();
      else {
        var t = (e.defaultView || window).getSelection();
        t && t.type !== "Caret" && t.removeAllRanges();
      }
    } catch {
    }
}
function un(e, t) {
  e.classList ? e.classList.add(t) : e.className.match(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"))) || (e.className += " ".concat(t));
}
function ln(e, t) {
  e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"), "g"), "");
}
var Pe = {};
Object.defineProperty(Pe, "__esModule", {
  value: !0
});
Pe.canDragX = Ha;
Pe.canDragY = Va;
Pe.createCoreData = Xa;
Pe.createDraggableData = Ka;
Pe.getBoundPosition = Ya;
Pe.getControlPosition = za;
Pe.snapToGrid = Ba;
var de = Ce, Xe = Q;
function Ya(e, t, n) {
  if (!e.props.bounds) return [t, n];
  var r = e.props.bounds;
  r = typeof r == "string" ? r : Ga(r);
  var a = tr(e);
  if (typeof r == "string") {
    var s = a.ownerDocument, v = s.defaultView, i;
    if (r === "parent" ? i = a.parentNode : i = s.querySelector(r), !(i instanceof v.HTMLElement))
      throw new Error('Bounds selector "' + r + '" could not find an element.');
    var _ = i, m = v.getComputedStyle(a), g = v.getComputedStyle(_);
    r = {
      left: -a.offsetLeft + (0, de.int)(g.paddingLeft) + (0, de.int)(m.marginLeft),
      top: -a.offsetTop + (0, de.int)(g.paddingTop) + (0, de.int)(m.marginTop),
      right: (0, Xe.innerWidth)(_) - (0, Xe.outerWidth)(a) - a.offsetLeft + (0, de.int)(g.paddingRight) - (0, de.int)(m.marginRight),
      bottom: (0, Xe.innerHeight)(_) - (0, Xe.outerHeight)(a) - a.offsetTop + (0, de.int)(g.paddingBottom) - (0, de.int)(m.marginBottom)
    };
  }
  return (0, de.isNum)(r.right) && (t = Math.min(t, r.right)), (0, de.isNum)(r.bottom) && (n = Math.min(n, r.bottom)), (0, de.isNum)(r.left) && (t = Math.max(t, r.left)), (0, de.isNum)(r.top) && (n = Math.max(n, r.top)), [t, n];
}
function Ba(e, t, n) {
  var r = Math.round(t / e[0]) * e[0], a = Math.round(n / e[1]) * e[1];
  return [r, a];
}
function Ha(e) {
  return e.props.axis === "both" || e.props.axis === "x";
}
function Va(e) {
  return e.props.axis === "both" || e.props.axis === "y";
}
function za(e, t, n) {
  var r = typeof t == "number" ? (0, Xe.getTouch)(e, t) : null;
  if (typeof t == "number" && !r) return null;
  var a = tr(n), s = n.props.offsetParent || a.offsetParent || a.ownerDocument.body;
  return (0, Xe.offsetXYFromParent)(r || e, s, n.props.scale);
}
function Xa(e, t, n) {
  var r = e.state, a = !(0, de.isNum)(r.lastX), s = tr(e);
  return a ? {
    node: s,
    deltaX: 0,
    deltaY: 0,
    lastX: t,
    lastY: n,
    x: t,
    y: n
  } : {
    node: s,
    deltaX: t - r.lastX,
    deltaY: n - r.lastY,
    lastX: r.lastX,
    lastY: r.lastY,
    x: t,
    y: n
  };
}
function Ka(e, t) {
  var n = e.props.scale;
  return {
    node: t.node,
    x: e.state.x + t.deltaX / n,
    y: e.state.y + t.deltaY / n,
    deltaX: t.deltaX / n,
    deltaY: t.deltaY / n,
    lastX: e.state.x,
    lastY: e.state.y
  };
}
function Ga(e) {
  return {
    left: e.left,
    top: e.top,
    right: e.right,
    bottom: e.bottom
  };
}
function tr(e) {
  var t = e.findDOMNode();
  if (!t)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return t;
}
var Et = {}, St = {};
Object.defineProperty(St, "__esModule", {
  value: !0
});
St.default = Ja;
function Ja() {
}
function ht(e) {
  "@babel/helpers - typeof";
  return ht = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ht(e);
}
Object.defineProperty(Et, "__esModule", {
  value: !0
});
Et.default = void 0;
var $t = Qa(Ke), fe = rr(bt), Za = rr(Kt), oe = Q, Ae = Pe, Ft = Ce, nt = rr(St);
function rr(e) {
  return e && e.__esModule ? e : { default: e };
}
function cn(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (cn = function(a) {
    return a ? n : t;
  })(e);
}
function Qa(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || ht(e) !== "object" && typeof e != "function")
    return { default: e };
  var n = cn(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
      var v = a ? Object.getOwnPropertyDescriptor(e, s) : null;
      v && (v.get || v.set) ? Object.defineProperty(r, s, v) : r[s] = e[s];
    }
  return r.default = e, n && n.set(e, r), r;
}
function Wr(e, t) {
  return ni(e) || ri(e, t) || ti(e, t) || ei();
}
function ei() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ti(e, t) {
  if (e) {
    if (typeof e == "string") return $r(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $r(e, t);
  }
}
function $r(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ri(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, s = !1, v, i;
    try {
      for (n = n.call(e); !(a = (v = n.next()).done) && (r.push(v.value), !(t && r.length === t)); a = !0)
        ;
    } catch (_) {
      s = !0, i = _;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (s) throw i;
      }
    }
    return r;
  }
}
function ni(e) {
  if (Array.isArray(e)) return e;
}
function oi(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ai(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ii(e, t, n) {
  return t && ai(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function si(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Xt(e, t);
}
function Xt(e, t) {
  return Xt = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Xt(e, t);
}
function ui(e) {
  var t = ci();
  return function() {
    var r = gt(e), a;
    if (t) {
      var s = gt(this).constructor;
      a = Reflect.construct(r, arguments, s);
    } else
      a = r.apply(this, arguments);
    return li(this, a);
  };
}
function li(e, t) {
  if (t && (ht(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ae(e);
}
function ae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ci() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function gt(e) {
  return gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, gt(e);
}
function he(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var _e = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
}, Ie = _e.mouse, wt = /* @__PURE__ */ function(e) {
  si(n, e);
  var t = ui(n);
  function n() {
    var r;
    oi(this, n);
    for (var a = arguments.length, s = new Array(a), v = 0; v < a; v++)
      s[v] = arguments[v];
    return r = t.call.apply(t, [this].concat(s)), he(ae(r), "state", {
      dragging: !1,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    }), he(ae(r), "mounted", !1), he(ae(r), "handleDragStart", function(i) {
      if (r.props.onMouseDown(i), !r.props.allowAnyClick && typeof i.button == "number" && i.button !== 0) return !1;
      var _ = r.findDOMNode();
      if (!_ || !_.ownerDocument || !_.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      var m = _.ownerDocument;
      if (!(r.props.disabled || !(i.target instanceof m.defaultView.Node) || r.props.handle && !(0, oe.matchesSelectorAndParentsTo)(i.target, r.props.handle, _) || r.props.cancel && (0, oe.matchesSelectorAndParentsTo)(i.target, r.props.cancel, _))) {
        i.type === "touchstart" && i.preventDefault();
        var g = (0, oe.getTouchIdentifier)(i);
        r.setState({
          touchIdentifier: g
        });
        var h = (0, Ae.getControlPosition)(i, g, ae(r));
        if (h != null) {
          var O = h.x, D = h.y, I = (0, Ae.createCoreData)(ae(r), O, D);
          (0, nt.default)("DraggableCore: handleDragStart: %j", I), (0, nt.default)("calling", r.props.onStart);
          var j = r.props.onStart(i, I);
          j === !1 || r.mounted === !1 || (r.props.enableUserSelectHack && (0, oe.addUserSelectStyles)(m), r.setState({
            dragging: !0,
            lastX: O,
            lastY: D
          }), (0, oe.addEvent)(m, Ie.move, r.handleDrag), (0, oe.addEvent)(m, Ie.stop, r.handleDragStop));
        }
      }
    }), he(ae(r), "handleDrag", function(i) {
      var _ = (0, Ae.getControlPosition)(i, r.state.touchIdentifier, ae(r));
      if (_ != null) {
        var m = _.x, g = _.y;
        if (Array.isArray(r.props.grid)) {
          var h = m - r.state.lastX, O = g - r.state.lastY, D = (0, Ae.snapToGrid)(r.props.grid, h, O), I = Wr(D, 2);
          if (h = I[0], O = I[1], !h && !O) return;
          m = r.state.lastX + h, g = r.state.lastY + O;
        }
        var j = (0, Ae.createCoreData)(ae(r), m, g);
        (0, nt.default)("DraggableCore: handleDrag: %j", j);
        var Y = r.props.onDrag(i, j);
        if (Y === !1 || r.mounted === !1) {
          try {
            r.handleDragStop(new MouseEvent("mouseup"));
          } catch {
            var F = document.createEvent("MouseEvents");
            F.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), r.handleDragStop(F);
          }
          return;
        }
        r.setState({
          lastX: m,
          lastY: g
        });
      }
    }), he(ae(r), "handleDragStop", function(i) {
      if (r.state.dragging) {
        var _ = (0, Ae.getControlPosition)(i, r.state.touchIdentifier, ae(r));
        if (_ != null) {
          var m = _.x, g = _.y;
          if (Array.isArray(r.props.grid)) {
            var h = m - r.state.lastX || 0, O = g - r.state.lastY || 0, D = (0, Ae.snapToGrid)(r.props.grid, h, O), I = Wr(D, 2);
            h = I[0], O = I[1], m = r.state.lastX + h, g = r.state.lastY + O;
          }
          var j = (0, Ae.createCoreData)(ae(r), m, g), Y = r.props.onStop(i, j);
          if (Y === !1 || r.mounted === !1) return !1;
          var F = r.findDOMNode();
          F && r.props.enableUserSelectHack && (0, oe.removeUserSelectStyles)(F.ownerDocument), (0, nt.default)("DraggableCore: handleDragStop: %j", j), r.setState({
            dragging: !1,
            lastX: NaN,
            lastY: NaN
          }), F && ((0, nt.default)("DraggableCore: Removing handlers"), (0, oe.removeEvent)(F.ownerDocument, Ie.move, r.handleDrag), (0, oe.removeEvent)(F.ownerDocument, Ie.stop, r.handleDragStop));
        }
      }
    }), he(ae(r), "onMouseDown", function(i) {
      return Ie = _e.mouse, r.handleDragStart(i);
    }), he(ae(r), "onMouseUp", function(i) {
      return Ie = _e.mouse, r.handleDragStop(i);
    }), he(ae(r), "onTouchStart", function(i) {
      return Ie = _e.touch, r.handleDragStart(i);
    }), he(ae(r), "onTouchEnd", function(i) {
      return Ie = _e.touch, r.handleDragStop(i);
    }), r;
  }
  return ii(n, [{
    key: "componentDidMount",
    value: function() {
      this.mounted = !0;
      var a = this.findDOMNode();
      a && (0, oe.addEvent)(a, _e.touch.start, this.onTouchStart, {
        passive: !1
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.findDOMNode();
      if (a) {
        var s = a.ownerDocument;
        (0, oe.removeEvent)(s, _e.mouse.move, this.handleDrag), (0, oe.removeEvent)(s, _e.touch.move, this.handleDrag), (0, oe.removeEvent)(s, _e.mouse.stop, this.handleDragStop), (0, oe.removeEvent)(s, _e.touch.stop, this.handleDragStop), (0, oe.removeEvent)(a, _e.touch.start, this.onTouchStart, {
          passive: !1
        }), this.props.enableUserSelectHack && (0, oe.removeUserSelectStyles)(s);
      }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
  }, {
    key: "findDOMNode",
    value: function() {
      var a, s, v;
      return (a = this.props) !== null && a !== void 0 && a.nodeRef ? (s = this.props) === null || s === void 0 || (v = s.nodeRef) === null || v === void 0 ? void 0 : v.current : Za.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ $t.cloneElement($t.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]), n;
}($t.Component);
Et.default = wt;
he(wt, "displayName", "DraggableCore");
he(wt, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: fe.default.bool,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: fe.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: fe.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(t, n) {
    if (t[n] && t[n].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: fe.default.arrayOf(fe.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: fe.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: fe.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: fe.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: fe.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: fe.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: fe.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: fe.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: fe.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: Ft.dontSetMe,
  style: Ft.dontSetMe,
  transform: Ft.dontSetMe
});
he(wt, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(e) {
  function t(u) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
      return typeof c;
    } : function(c) {
      return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    }, t(u);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return m.default;
    }
  }), e.default = void 0;
  var n = I(Ke), r = O(bt), a = O(Kt), s = O(ba), v = Q, i = Pe, _ = Ce, m = O(Et), g = O(St), h = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
  function O(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function D(u) {
    if (typeof WeakMap != "function") return null;
    var c = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (D = function(p) {
      return p ? f : c;
    })(u);
  }
  function I(u, c) {
    if (u && u.__esModule)
      return u;
    if (u === null || t(u) !== "object" && typeof u != "function")
      return { default: u };
    var f = D(c);
    if (f && f.has(u))
      return f.get(u);
    var y = {}, p = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var S in u)
      if (S !== "default" && Object.prototype.hasOwnProperty.call(u, S)) {
        var P = p ? Object.getOwnPropertyDescriptor(u, S) : null;
        P && (P.get || P.set) ? Object.defineProperty(y, S, P) : y[S] = u[S];
      }
    return y.default = u, f && f.set(u, y), y;
  }
  function j() {
    return j = Object.assign || function(u) {
      for (var c = 1; c < arguments.length; c++) {
        var f = arguments[c];
        for (var y in f)
          Object.prototype.hasOwnProperty.call(f, y) && (u[y] = f[y]);
      }
      return u;
    }, j.apply(this, arguments);
  }
  function Y(u, c) {
    if (u == null) return {};
    var f = F(u, c), y, p;
    if (Object.getOwnPropertySymbols) {
      var S = Object.getOwnPropertySymbols(u);
      for (p = 0; p < S.length; p++)
        y = S[p], !(c.indexOf(y) >= 0) && Object.prototype.propertyIsEnumerable.call(u, y) && (f[y] = u[y]);
    }
    return f;
  }
  function F(u, c) {
    if (u == null) return {};
    var f = {}, y = Object.keys(u), p, S;
    for (S = 0; S < y.length; S++)
      p = y[S], !(c.indexOf(p) >= 0) && (f[p] = u[p]);
    return f;
  }
  function X(u, c) {
    var f = Object.keys(u);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(u);
      c && (y = y.filter(function(p) {
        return Object.getOwnPropertyDescriptor(u, p).enumerable;
      })), f.push.apply(f, y);
    }
    return f;
  }
  function q(u) {
    for (var c = 1; c < arguments.length; c++) {
      var f = arguments[c] != null ? arguments[c] : {};
      c % 2 ? X(Object(f), !0).forEach(function(y) {
        d(u, y, f[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(f)) : X(Object(f)).forEach(function(y) {
        Object.defineProperty(u, y, Object.getOwnPropertyDescriptor(f, y));
      });
    }
    return u;
  }
  function G(u, c) {
    return ye(u) || Re(u, c) || le(u, c) || T();
  }
  function T() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function le(u, c) {
    if (u) {
      if (typeof u == "string") return Te(u, c);
      var f = Object.prototype.toString.call(u).slice(8, -1);
      if (f === "Object" && u.constructor && (f = u.constructor.name), f === "Map" || f === "Set") return Array.from(u);
      if (f === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(f)) return Te(u, c);
    }
  }
  function Te(u, c) {
    (c == null || c > u.length) && (c = u.length);
    for (var f = 0, y = new Array(c); f < c; f++)
      y[f] = u[f];
    return y;
  }
  function Re(u, c) {
    var f = u == null ? null : typeof Symbol < "u" && u[Symbol.iterator] || u["@@iterator"];
    if (f != null) {
      var y = [], p = !0, S = !1, P, N;
      try {
        for (f = f.call(u); !(p = (P = f.next()).done) && (y.push(P.value), !(c && y.length === c)); p = !0)
          ;
      } catch (R) {
        S = !0, N = R;
      } finally {
        try {
          !p && f.return != null && f.return();
        } finally {
          if (S) throw N;
        }
      }
      return y;
    }
  }
  function ye(u) {
    if (Array.isArray(u)) return u;
  }
  function De(u, c) {
    if (!(u instanceof c))
      throw new TypeError("Cannot call a class as a function");
  }
  function ge(u, c) {
    for (var f = 0; f < c.length; f++) {
      var y = c[f];
      y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(u, y.key, y);
    }
  }
  function ce(u, c, f) {
    return c && ge(u.prototype, c), f && ge(u, f), Object.defineProperty(u, "prototype", { writable: !1 }), u;
  }
  function re(u, c) {
    if (typeof c != "function" && c !== null)
      throw new TypeError("Super expression must either be null or a function");
    u.prototype = Object.create(c && c.prototype, { constructor: { value: u, writable: !0, configurable: !0 } }), Object.defineProperty(u, "prototype", { writable: !1 }), c && x(u, c);
  }
  function x(u, c) {
    return x = Object.setPrototypeOf || function(y, p) {
      return y.__proto__ = p, y;
    }, x(u, c);
  }
  function A(u) {
    var c = M();
    return function() {
      var y = z(u), p;
      if (c) {
        var S = z(this).constructor;
        p = Reflect.construct(y, arguments, S);
      } else
        p = y.apply(this, arguments);
      return k(this, p);
    };
  }
  function k(u, c) {
    if (c && (t(c) === "object" || typeof c == "function"))
      return c;
    if (c !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return l(u);
  }
  function l(u) {
    if (u === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return u;
  }
  function M() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function z(u) {
    return z = Object.setPrototypeOf ? Object.getPrototypeOf : function(f) {
      return f.__proto__ || Object.getPrototypeOf(f);
    }, z(u);
  }
  function d(u, c, f) {
    return c in u ? Object.defineProperty(u, c, { value: f, enumerable: !0, configurable: !0, writable: !0 }) : u[c] = f, u;
  }
  var E = /* @__PURE__ */ function(u) {
    re(f, u);
    var c = A(f);
    function f(y) {
      var p;
      return De(this, f), p = c.call(this, y), d(l(p), "onDragStart", function(S, P) {
        (0, g.default)("Draggable: onDragStart: %j", P);
        var N = p.props.onStart(S, (0, i.createDraggableData)(l(p), P));
        if (N === !1) return !1;
        p.setState({
          dragging: !0,
          dragged: !0
        });
      }), d(l(p), "onDrag", function(S, P) {
        if (!p.state.dragging) return !1;
        (0, g.default)("Draggable: onDrag: %j", P);
        var N = (0, i.createDraggableData)(l(p), P), R = {
          x: N.x,
          y: N.y
        };
        if (p.props.bounds) {
          var J = R.x, w = R.y;
          R.x += p.state.slackX, R.y += p.state.slackY;
          var ne = (0, i.getBoundPosition)(l(p), R.x, R.y), ue = G(ne, 2), be = ue[0], xe = ue[1];
          R.x = be, R.y = xe, R.slackX = p.state.slackX + (J - R.x), R.slackY = p.state.slackY + (w - R.y), N.x = R.x, N.y = R.y, N.deltaX = R.x - p.state.x, N.deltaY = R.y - p.state.y;
        }
        var We = p.props.onDrag(S, N);
        if (We === !1) return !1;
        p.setState(R);
      }), d(l(p), "onDragStop", function(S, P) {
        if (!p.state.dragging) return !1;
        var N = p.props.onStop(S, (0, i.createDraggableData)(l(p), P));
        if (N === !1) return !1;
        (0, g.default)("Draggable: onDragStop: %j", P);
        var R = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        }, J = !!p.props.position;
        if (J) {
          var w = p.props.position, ne = w.x, ue = w.y;
          R.x = ne, R.y = ue;
        }
        p.setState(R);
      }), p.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: y.position ? y.position.x : y.defaultPosition.x,
        y: y.position ? y.position.y : y.defaultPosition.y,
        prevPropsPosition: q({}, y.position),
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, y.position && !(y.onDrag || y.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element."), p;
    }
    return ce(f, [{
      key: "componentDidMount",
      value: function() {
        typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
          isElementSVG: !0
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.setState({
          dragging: !1
        });
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
    }, {
      key: "findDOMNode",
      value: function() {
        var p, S, P;
        return (p = (S = this.props) === null || S === void 0 || (P = S.nodeRef) === null || P === void 0 ? void 0 : P.current) !== null && p !== void 0 ? p : a.default.findDOMNode(this);
      }
    }, {
      key: "render",
      value: function() {
        var p, S = this.props;
        S.axis, S.bounds;
        var P = S.children, N = S.defaultPosition, R = S.defaultClassName, J = S.defaultClassNameDragging, w = S.defaultClassNameDragged, ne = S.position, ue = S.positionOffset;
        S.scale;
        var be = Y(S, h), xe = {}, We = null, st = !!ne, $e = !st || this.state.dragging, ut = ne || N, lt = {
          // Set left if horizontal drag is enabled
          x: (0, i.canDragX)(this) && $e ? this.state.x : ut.x,
          // Set top if vertical drag is enabled
          y: (0, i.canDragY)(this) && $e ? this.state.y : ut.y
        };
        this.state.isElementSVG ? We = (0, v.createSVGTransform)(lt, ue) : xe = (0, v.createCSSTransform)(lt, ue);
        var Qe = (0, s.default)(P.props.className || "", R, (p = {}, d(p, J, this.state.dragging), d(p, w, this.state.dragged), p));
        return /* @__PURE__ */ n.createElement(m.default, j({}, be, {
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop
        }), /* @__PURE__ */ n.cloneElement(n.Children.only(P), {
          className: Qe,
          style: q(q({}, P.props.style), xe),
          transform: We
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: (
        // React 16.3+
        // Arity (props, state)
        function(p, S) {
          var P = p.position, N = S.prevPropsPosition;
          return P && (!N || P.x !== N.x || P.y !== N.y) ? ((0, g.default)("Draggable: getDerivedStateFromProps %j", {
            position: P,
            prevPropsPosition: N
          }), {
            x: P.x,
            y: P.y,
            prevPropsPosition: q({}, P)
          }) : null;
        }
      )
    }]), f;
  }(n.Component);
  e.default = E, d(E, "displayName", "Draggable"), d(E, "propTypes", q(q({}, m.default.propTypes), {}, {
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: r.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: r.default.oneOfType([r.default.shape({
      left: r.default.number,
      right: r.default.number,
      top: r.default.number,
      bottom: r.default.number
    }), r.default.string, r.default.oneOf([!1])]),
    defaultClassName: r.default.string,
    defaultClassNameDragging: r.default.string,
    defaultClassNameDragged: r.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: r.default.shape({
      x: r.default.number,
      y: r.default.number
    }),
    positionOffset: r.default.shape({
      x: r.default.oneOfType([r.default.number, r.default.string]),
      y: r.default.oneOfType([r.default.number, r.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: r.default.shape({
      x: r.default.number,
      y: r.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: _.dontSetMe,
    style: _.dontSetMe,
    transform: _.dontSetMe
  })), d(E, "defaultProps", q(q({}, m.default.defaultProps), {}, {
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  }));
})(Qr);
var fn = Qr, dn = fn.default, fi = fn.DraggableCore;
Ot.exports = dn;
Ot.exports.default = dn;
Ot.exports.DraggableCore = fi;
var di = Ot.exports;
const pi = /* @__PURE__ */ Gt(di), vi = "_wrapper_la23x_1", yi = "_controller_la23x_34", mi = "_dragIcon_la23x_42", hi = "_content_la23x_50", pt = {
  wrapper: vi,
  controller: yi,
  dragIcon: mi,
  content: hi
}, gi = (e) => {
  let t = Fr(e);
  return Mn(() => {
    t.current = e;
  }), Nn(() => (...n) => {
    const { current: r } = t;
    return r(...n);
  }, []);
}, bi = ({ position: e, ref: t, onPositionChange: n }) => {
  const r = gi((a) => {
    var D, I, j;
    const {
      contentRect: { height: s, width: v }
    } = a[0], i = ((D = t.current) == null ? void 0 : D.offsetTop) ?? 0, _ = ((I = t.current) == null ? void 0 : I.offsetLeft) ?? 0, m = (j = t.current) == null ? void 0 : j.parentElement, g = (m == null ? void 0 : m.clientHeight) || 0, h = (m == null ? void 0 : m.clientWidth) || 0, O = {
      // x,y values relative to parent element
      x: e.x + _,
      y: e.y + i
    };
    O.y + s > g && (O.y = g - s), O.y < 0 && (O.y = 0), O.x + v > h && (O.x = h - v), O.x < 0 && (O.x = 0), n({
      // remove the default positions to get values relative to default position not parent
      x: O.x - _,
      y: O.y - i
    });
  });
  An(() => {
    const a = new ResizeObserver(r);
    return a.observe(t.current), () => {
      a.disconnect();
    };
  }, [t, r]);
}, _i = ({
  onCloseButtonClick: e,
  children: t,
  bounds: n = "parent",
  testId: r,
  position: a,
  onPositionChange: s,
  ...v
}) => {
  const i = Fr(null), { disabled: _ } = v, m = (g, h) => {
    s(h);
  };
  return bi({ position: a, ref: i, onPositionChange: s }), /* @__PURE__ */ Z.jsx(
    pi,
    {
      ...v,
      position: a,
      nodeRef: i,
      bounds: n,
      handle: ".floatingButtonHandle",
      onDrag: m,
      children: /* @__PURE__ */ Z.jsxs(
        "div",
        {
          ref: i,
          className: pt.wrapper,
          ...jt("drag-modal", r),
          children: [
            /* @__PURE__ */ Z.jsxs("div", { className: pt.controller, children: [
              /* @__PURE__ */ Z.jsx("div", { children: !_ && /* @__PURE__ */ Z.jsx(
                "div",
                {
                  className: ha(pt.dragIcon, "floatingButtonHandle"),
                  ...jt("drag-icon", r),
                  children: /* @__PURE__ */ Z.jsx(kr, { icon: "DragBoldStroke" })
                }
              ) }),
              /* @__PURE__ */ Z.jsx(
                Wn,
                {
                  icon: "CloseBoldStroke",
                  onClick: e,
                  "aria-label": "close",
                  variant: "tertiary",
                  ...jt("close-button", r)
                }
              )
            ] }),
            /* @__PURE__ */ Z.jsx("div", { className: pt.content, children: t })
          ]
        }
      )
    }
  );
}, Ci = ({ isOpen: e, defaultPosition: t, ...n }) => {
  const [r, a] = In(() => ({
    x: (t == null ? void 0 : t.x) ?? 0,
    y: (t == null ? void 0 : t.y) ?? 0
  })), s = (v) => {
    const { x: i, y: _ } = v;
    a((m) => i === m.x && _ === m.y ? m : { x: i, y: _ });
  };
  return e ? /* @__PURE__ */ Z.jsx(_i, { ...n, position: r, onPositionChange: s }) : null;
};
export {
  Ci as FloatingModal,
  Ti as Modal
};
